export default __webpack_public_path__ + "img/dwsboXUT.80e92c33.svg";